import React from 'react';
import { TodayIndicator } from './CalendarHeader.styled';
import LeftArrow from 'src/assets/images/LeftArrow.svg';
import RightArrow from 'src/assets/images/RightArrow.svg';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useCalendarHeaderNavigation from '../hooks/useCalendarHeaderNavigation';
import { DATE_FORMAT, LOCALE } from 'src/constants/appConstants';
import { logErrorToConsole } from 'src/utils/util';

const CalendarHeader = ({ showTodayButton, changeSelectedDate }) => {
    const { t } = useTranslation();
    const selectedDate = useSelector((state) => state.filterReducer.selectedDate);
    const visibleDateRange = useSelector((state) => state.filterReducer.visibleDateRange);
    const calendarView = useSelector((state) => state.filterReducer.calendarView);
    const { toggleWeek, toggleMonth } = useCalendarHeaderNavigation();

    return (
        <div className="calendar-header">
            {(() => {
                if (calendarView === 'Week') {
                    let fromDate = new Intl.DateTimeFormat(LOCALE, {
                        day: DATE_FORMAT.DAY,
                    }).format(visibleDateRange[0]);
                    let fromMonth = new Intl.DateTimeFormat(LOCALE, {
                        month: DATE_FORMAT.MONTH,
                    }).format(visibleDateRange[0]);
                    let toDate = new Intl.DateTimeFormat(LOCALE, {
                        day: DATE_FORMAT.DAY,
                    }).format(visibleDateRange[1]);
                    let toMonth = new Intl.DateTimeFormat(LOCALE, {
                        month: DATE_FORMAT.MONTH,
                    }).format(visibleDateRange[1]);
                    let toYear = new Intl.DateTimeFormat(LOCALE, {
                        year: DATE_FORMAT.YEAR,
                    }).format(visibleDateRange[1]);

                    const weekDateString = `${fromDate} ${fromMonth} - ${toDate} ${toMonth} ${toYear}`; 
                    return (
                        <>
                            <div
                                className="month-week-nav"
                                onClick={() => {
                                    try {
                                        toggleWeek('previous');
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            >
                                <img
                                    src={LeftArrow}
                                    alt="left arrow"
                                    width="auto"
                                    height="auto"
                                ></img>
                            </div>
                            <div className="header-title-container">
                                <div className="header-title">{weekDateString}</div>
                            </div>
                            <div
                                className="month-week-nav"
                                onClick={() => {
                                    try {
                                        toggleWeek('next');
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            >
                                <img
                                    src={RightArrow}
                                    alt="right arrow"
                                    width="auto"
                                    height="auto"
                                ></img>
                            </div>
                        </>
                    );
                }
                if (calendarView === 'Month') {
                    let month = new Intl.DateTimeFormat(LOCALE, {
                        month: DATE_FORMAT.MONTH,
                    }).format(selectedDate);
                    let year = new Intl.DateTimeFormat(LOCALE, {
                        year: DATE_FORMAT.YEAR,
                    }).format(selectedDate);

                    const monthDateString = `${month} ${year}`; 
                    return (
                        <>
                            {showTodayButton && (
                                <TodayIndicator
                                    onClick={() => {
                                        try {
                                            changeSelectedDate(
                                                new Date(
                                                    new Date().setHours(0, 0, 0, 0)
                                                )
                                            );
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                >
                                    {t('orders.todayLabel')}
                                </TodayIndicator>
                            )}
                            <div style={{ display: 'flex' }}>
                                <div
                                    className="month-week-nav"
                                    onClick={() => {
                                        try {
                                            toggleMonth('previous');
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                >
                                    <img
                                        src={LeftArrow}
                                        alt="left arrow"
                                        style={{ cursor: 'pointer' }}
                                        width="auto"
                                        height="auto"
                                    ></img>
                                </div>
                                <div className="header-title-container">
                                    <div className="header-title">{monthDateString}</div>
                                </div>
                                <div
                                    className="month-week-nav"
                                    onClick={() => {
                                        try {
                                            toggleMonth('next');
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                >
                                    <img
                                        src={RightArrow}
                                        alt="right arrow"
                                        style={{ cursor: 'pointer' }}
                                        width="auto"
                                        height="auto"
                                    ></img>
                                </div>
                            </div>
                        </>
                    );
                }
            })()}
        </div>
    );
};

export default CalendarHeader;
